<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/supplier">Fornecedores</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Atualizar dados fiscais</li>
                <li class="breadcrumb-item active" aria-current="page">{{ supplier.name }}</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <ul class="nav nav-tabs" role="tablist">
                    <li class="nav-item">
                        <router-link :to="{
                            name: 'supplier_edit',
                            params: { id: this.supplier.id }
                        }" role="tab" data-toggle="tab" class="nav-link"> Dados gerais </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{
                            name: 'supplier_address_edit',
                            params: { id: this.supplier.id }
                        }" role="tab" data-toggle="tab" class="nav-link">
                            Endereço </router-link>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{
                            name: 'supplier_fiscal_edit',
                            params: { id: this.supplier.id }
                        }" role="tab" data-toggle="tab" class="nav-link active">
                            Dados fiscais </router-link>
                    </li>
                </ul>
                <div class="tab-content">
                    <div class="tab-pane active" role="tabpanel" id="info">
                        <div class="card shadow mb-4">
                            <!-- Card Header - Dropdown -->
                            <div class="card-body">
                                <form @submit="update">
                                    <div class="row mt-1">
                                        <div class="col-xl-12 col-md-12 col-sm-12">
                                            <label for="">CNPJ*</label>
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control"
                                                    placeholder="Ex: xx.xxx.xxx/xxxx-xx" v-model="supplier.document"
                                                    disabled>
                                                <div class="input-group-append">
                                                    <button class="btn btn-success" type="button" id="button-addon2"
                                                        :disabled="searchCnpj" @click="searchCNPJ()"><i
                                                            class="fa fa-search"></i>Buscar
                                                        Dados fiscais pelo CNPJ</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-1">
                                        <div class="col-xl-12 col-md-12 col-sm-12">
                                            <label for="">Regime Tributário*</label>
                                            <div class="input-group mb-3">
                                                <select class="form-control" v-model="supplier_fiscal.tax_regime">
                                                    <option value="" disabled selected>Selecione uma opção</option>
                                                    <option value="Simples Nacional">Simples Nacional</option>
                                                    <option value="Lucro Presumido">Lucro Presumido</option>
                                                    <option value="Lucro Real">Lucro Real</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-1">
                                        <div class="col-xl-4 col-md-4 col-sm-12">
                                            <label for="">CNAE Fiscal</label>
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control" placeholder="Ex: xxxxx"
                                                    v-model="supplier_fiscal.cnae_fiscal">
                                            </div>
                                        </div>
                                        <div class="col-xl-8 col-md-8 col-sm-12">
                                            <label for="">Descrição CNAE</label>
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control" placeholder="Ex: xxxxx"
                                                    v-model="supplier_fiscal.cnae_fiscal_description">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-1">
                                        <div class="col-xl-6 col-md-6 col-sm-12">
                                            <label for="">Inscrição Estadual</label>
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control" placeholder="Ex: xxxxx"
                                                    v-model="supplier_fiscal.state_registration" v-mask="['############']">
                                            </div>
                                        </div>
                                        <div class="col-xl-6 col-md-6 col-sm-12">
                                            <label for="">Inscrição Municipal*</label>
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control" placeholder="Ex: xxxxx"
                                                    v-model="supplier_fiscal.municipal_registration" >
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-1">
                                        <div class="col-xl-3 col-md-4 col-sm-12">
                                            <label for="">Data situação cadastral</label>
                                            <div class="input-group mb-3">
                                                <input type="date" class="form-control"
                                                    v-model="supplier_fiscal.date_situation_cadastral">
                                            </div>
                                        </div>
                                        <div class="col-xl-3 col-md-4 col-sm-12">
                                            <label for="">Natureza jurídica</label>
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control" placeholder="Ex: xxxxx"
                                                    v-model="supplier_fiscal.legal_nature">
                                            </div>
                                        </div>
                                        <div class="col-xl-3 col-md-4 col-sm-12">
                                            <label for="">Situação cadastral</label>
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control" placeholder="Ex: xxxxx"
                                                    v-model="supplier_fiscal.situation_cadastral">
                                            </div>
                                        </div>
                                        <div class="col-xl-3 col-md-3 col-sm-12">
                                            <label for="">Tamanho empresa</label>
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control" placeholder="Ex: xxxxx"
                                                    v-model="supplier_fiscal.company_size">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-1">
                                        <div class="col-xl-3 col-md-3 col-sm-12">
                                            <label for="">Banco</label>
                                                <multiselect v-model="bank_multiselect" :options="banks_options"
                                                :custom-label="bankWithLang" placeholder="Selecione uma opção"
                                                :select-label="'Clique para selecionar'"
                                                :deselect-label="'Clique para remover'" @select="handleSelectBank">
                                                <template #noResult>
                                                    Nenhum banco encontrado.
                                                </template>
                                            </multiselect>
                                          
                                        </div>
                                        <div class="col-xl-3 col-md-3 col-sm-12">
                                            <label for="">Agência</label>
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control" placeholder="Ex: xxxxx"
                                                    v-model="supplier_fiscal.agency">
                                            </div>
                                        </div>
                                        <div class="col-xl-3 col-md-3 col-sm-12">
                                            <label for="">Conta</label>
                                            <div class="input-group mb-3">
                                                <input type="text" class="form-control" placeholder="Ex: xxxxx"
                                                    v-model="supplier_fiscal.account">
                                            </div>
                                        </div>
                                        <div class="col-xl-3 col-md-3 col-sm-12">
                                            <label for="">Tipo conta</label>
                                            <div class="input-group mb-3">
                                                <select class="form-control" v-model="supplier_fiscal.type_account">
                                                    <option value="" disabled selected>Escolha uma opção</option>
                                                    <option value="corrente">Conta Corrente</option>
                                                    <option value="corrente">Conta Poupança</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                     <div class="row mt-2 mb-4">
                                        <div class="col-lg-12 col-xs-12 col-sm-12">
                                            <label for="">Observações</label>
                                            <editorText @update-text="updateObservation"
                                                :modelValue="supplier_fiscal.observation" placeholderSend="Sem observações" ref="myChild"></editorText>
                                        </div>
                                    </div>
                                     <br> <br>
                                    <div class="row mt-3">
                                        <div class="col-xl-12 col-md-12 col-sm-12">
                                            <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                                    class="fa fa-save"></i> Atualizar</button>
                                            <router-link to="/supplier" class="btn btn-danger ml-3"><i
                                                    class="fa fa-times"></i>
                                                Cancelar</router-link>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { getCNPJ, loadBank } from '@/api-external';
import { handleRequestErrors } from '@/handleErrors';
import { capitalize } from '@/util';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { mask } from 'vue-the-mask'
import editorText from '../util/editor-text.vue';
import Multiselect from 'vue-multiselect'

export default {
    directives: { mask },
    components: { Loading,editorText,Multiselect },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            supplier: {},
            banks: {},
             bank_multiselect: '',
            banks_options: [],
            supplier_id: '',
            supplier_fiscal: {
                id: '',
                tax_regime: '',
                state_registration: '',
                municipal_registration: '',
                cnae_fiscal: '',
                cnae_fiscal_description: '',
                date_situation_cadastral: '',
                legal_nature: '',
                situation_cadastral: '',
                company_size: '',
                bank: '',
                agency: '',
                account: '',
                type_account: '',
                observation: ''
            },
            enable_error_list: false,
            errors: [],
            
        }
    },

    computed: {
        isDisabled: function () {
            return this.supplier_fiscal.tax_regime != '' && this.supplier_fiscal.municipal_registration;
        }
    },
    mounted() {
        this.isLoading = false;
        const id = this.$route.params.id;
        this.supplier_id = id;
        const response_banks = this.getBank();
         response_banks.then(() => {
            this.banks_options = this.banks.map(item => ({
                title: item.fullName,
                value: 'Código: ' + item.code + ' / ' + 'Banco: ' + capitalize(item.name)
            }));            
        });
        this.getFiscalSupplier();

    },
    methods: {
        onCancel() { },
        setCapitalize(text) {
            return capitalize(text);
        },
          handleSelectBank(option) {
            this.supplier_fiscal.bank = option.value;
        },
        async getBank() {
            this.isLoading = true;
            const response = await loadBank().then((response) => {
                let banks = response;
                banks.sort((a, b) => {
                    if (a.name > b.name) {
                        return 1;
                    }
                    if (a.name < b.name) {
                        return -1;
                    }
                    return 0;
                });
                this.banks = banks;

                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });

            return response;
        },
         bankWithLang({ value }) {
            return value;
        },
        
        searchCNPJ() {
            this.isLoading = true;
            if (this.supplier.document.length > 0) {
                let cnpj = this.supplier.document.replace(/\D/g, '');
                getCNPJ(cnpj).then((response) => {
                    this.supplier_fiscal.cnae_fiscal = response.cnae_fiscal;
                    this.supplier_fiscal.cnae_fiscal_description = capitalize(response.cnae_fiscal_descricao);
                    this.supplier_fiscal.date_situation_cadastral = response.data_situacao_cadastral;
                    this.supplier_fiscal.legal_nature = capitalize(response.natureza_juridica);
                    this.supplier_fiscal.situation_cadastral = capitalize(response.descricao_situacao_cadastral);
                    this.supplier_fiscal.company_size = capitalize(response.porte);

                    this.isLoading = false;
                }).catch(() => {
                    this.isLoading = false;
                });
            }
        },
        updateObservation(observation) {
           this.supplier_fiscal.observation = observation;
        },
        getFiscalSupplier() {
            api.get('/supplier/' + this.supplier_id + '/fiscal')
                .then((response) => {
                    this.isLoading = false;
                    this.supplier = response.data.supplier;
                    if (response.data.fiscal_supplier.length != 0) {
                        this.supplier_fiscal = response.data.fiscal_supplier;
                          this.$refs.myChild.updateTextEditor(this.supplier_fiscal.observation);
                           if(this.supplier_fiscal.bank){
                            this.bank_multiselect = {title:this.supplier_fiscal.bank,value:this.supplier_fiscal.bank};
                        }
                    }

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
        },

        update(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            api.post('/supplier/' + this.supplier.id + '/fiscal', this.supplier_fiscal)
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Dados fiscais do fornecedor atualizado com sucesso!",
                        type: 'success'
                    });
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status);
                })

        }
    }
}
</script>

<style lang="scss" scoped></style>